import {
  BillableItemIds,
  BillableItemPaymentModel,
  BillableItemStatus,
  BillableItemType,
  CurrencyCode,
  FeatureType
} from '../enums/billableItem';
import { BillableItem, Feature } from '../interfaces/billableItem';
import { telkomPlans } from './billableItemPlans/telkom';
import { appSumoPlans } from './billableItemPlans/appsumo';
import { shopifyPlans } from './billableItemPlans/shopify';
import { monthlyPlans, yearlyPlans } from './billableItemPlans/mobiz';
import { range } from '../../lib/utilities/array';
import {
  monthlyPlans2021,
  yearlyPlans2021
} from './billableItemPlans/legacyPlans/mobiz';

export const SystemContactLimit = +process.env.SystemContactLimit || 250000;

const baseChargeFeatures: Feature[] = [
  {
    type: FeatureType.Sms,
    quantity: 1
  }
];

const baseAddOnFeatures: Feature[] = [
  {
    type: FeatureType.Sms,
    quantity: 1
  }
];

const trialPlan: BillableItem = {
  id: BillableItemIds.Plan.TrialPackageUsdMonthly,
  name: 'Trial Package',
  type: BillableItemType.Plan,
  priceInCents: 0,
  currencyCode: CurrencyCode.USD,
  paymentModel: BillableItemPaymentModel.Trial,
  status: BillableItemStatus.Active,
  features: [
    // TODO: these quantities are pending confirmation
    { type: FeatureType.PictureMessaging, quantity: 1 },
    { type: FeatureType.MmsTextOverlay, quantity: 1 },
    {
      type: FeatureType.Sms,
      quantity: 100
    },
    {
      type: FeatureType.Contact,
      quantity: 100
    }
  ]
};

const addons: BillableItem[] = [
  {
    id: BillableItemIds.Addon.SmsRecurringUsdMonthly,
    name: 'SMS Recurring Monthly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    differentialPriceInCents: {
      default: 1,
      [BillableItemIds.Plan.StarterPlanUsdMonthly]: 1,
      [BillableItemIds.Plan.GrowthPlanUsdMonthly]: 1,
      [BillableItemIds.Plan.PremiumPlanUsdMonthly]: 1
    },
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.SmsRecurringUsdYearly,
    name: 'SMS Recurring Yearly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    differentialPriceInCents: {
      default: 1,
      [BillableItemIds.Plan.StarterPlanUsdYearly]: 1,
      [BillableItemIds.Plan.GrowthPlanUsdYearly]: 1,
      [BillableItemIds.Plan.PremiumPlanUsdYearly]: 1
    },
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Yearly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringSmsTextCreditsUsdMonthly,
    name: 'SMS Recurring Monthly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    differentialPriceInCents: {
      default: 1,
      [BillableItemIds.Plan.StarterUsdMonthly]: 1,
      [BillableItemIds.Plan.GrowthUsdMonthly]: 1,
      [BillableItemIds.Plan.ProUsdMonthly]: 1
    },
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringSmsTextCreditsUsdYearly,
    name: 'SMS Recurring Yearly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    differentialPriceInCents: {
      default: 1,
      [BillableItemIds.Plan.StarterUsdYearly]: 1,
      [BillableItemIds.Plan.GrowthUsdYearly]: 1,
      [BillableItemIds.Plan.ProUsdYearly]: 1
    },
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Yearly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringStarterSmsTextCreditsUsdMonthly,
    name: 'SMS Starter Recurring Monthly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringStarterSmsTextCreditsUsdYearly,
    name: 'SMS Starter Recurring Yearly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Yearly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringGrowthSmsTextCreditsUsdMonthly,
    name: 'SMS Growth Recurring Monthly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringGrowthSmsTextCreditsUsdYearly,
    name: 'SMS Growth Recurring Yearly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Yearly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringProSmsTextCreditsUsdMonthly,
    name: 'SMS Pro Recurring Monthly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringProSmsTextCreditsUsdYearly,
    name: 'SMS Pro Recurring Yearly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Yearly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  },
  {
    id: BillableItemIds.Addon.RecurringFreemiumSmsTextCreditsUsdMonthly,
    name: 'SMS Freemium Recurring Monthly',
    type: BillableItemType.Addon,
    priceInCents: 1,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: baseAddOnFeatures
  }
];

const charges: BillableItem[] = [
  {
    id: BillableItemIds.Charge.PayAsYouGoSmsBundleOnceOffUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 2,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  },
  {
    id: BillableItemIds.Charge.ShopifyFreemiumPayAsYouGoSmsBundleOnceOffUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 2,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  },
  {
    id: BillableItemIds.Charge.ShopifyGrowthPayAsYouGoSmsBundleOnceOffUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 1.3,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  },

  {
    id: BillableItemIds.Charge.PayAsYouGoTextCreditsOnceOffStarterUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 2.5,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  },
  {
    id: BillableItemIds.Charge.PayAsYouGoTextCreditsOnceOffGrowthUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 2,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  },
  {
    id: BillableItemIds.Charge.PayAsYouGoTextCreditsOnceOffProUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 1.5,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  },
  {
    id: BillableItemIds.Charge.PayAsYouGoTextCreditsOnceOffFreemiumUsd,
    name: '1000 Pay As You Go SMS Bundle',
    type: BillableItemType.Charge,
    priceInCents: 3,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.OneTime,
    status: BillableItemStatus.Active,
    features: baseChargeFeatures
  }
];

const closedBetaPlan: BillableItem = {
  id: BillableItemIds.Plan.ClosedBetaPackageUsdMonthly,
  name: 'Closed Beta Package',
  type: BillableItemType.Plan,
  priceInCents: 0,
  currencyCode: CurrencyCode.USD,
  paymentModel: BillableItemPaymentModel.Trial,
  status: BillableItemStatus.Active,
  features: [
    {
      type: FeatureType.Sms,
      quantity: 800
    },
    {
      type: FeatureType.Contact,
      quantity: 2000
    }
  ]
};

export const LatestMobizPlanIds = [
  ...monthlyPlans.map(x => x.id),
  ...yearlyPlans.map(x => x?.id)
];

export const BillableItems = [
  trialPlan,
  closedBetaPlan,
  ...monthlyPlans2021,
  ...yearlyPlans2021,
  ...monthlyPlans,
  ...yearlyPlans,
  ...addons,
  ...charges,
  ...telkomPlans,
  ...appSumoPlans,
  ...shopifyPlans
];

export const ShopifyPlansVariableCreditOptions = {
  freePlanOption: [0],
  growthPlanOptions: range(5000, 14000, 1000)
};

export const MobizPlansVariableCreditOptions = {
  freePlanOption: [0],
  starterPlanOptions: [2000, 2500, 3000, 3500],
  growthPlanOptions: range(5000, 12000, 1000),
  proPlanOptions: range(15000, 55000, 5000)
};
